import React, { useState, useRef, useEffect, useMemo } from 'react';
import { baseurl } from '../../../api';
import './CountrySelectWithFlag.css';

const CountrySelectWithFlag = ({
  label = 'Country',
  options = [],
  onChange,
  placeholder = 'Select Country',
  value = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (value !== null && value !== undefined) {
      const match = options.find(o => Number(o.value) === Number(value));
      if (match) setSelectedOption(match);
    } else {
      setSelectedOption(null);
    }
  }, [value, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchTerm.trim()) return options;
    return options.filter(option =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase().trim())
    );
  }, [options, searchTerm]);

  const handleSelect = (option) => {
    if (value === null || value === undefined) {
      setSelectedOption(null);
    } else {
      setSelectedOption(option);
    }
    setIsOpen(false);
    setSearchTerm('');
    if (onChange) {
      onChange({ target: { value: option.value } });
    }
  };

  const getFlagUrl = (flagPath) => {
    if (!flagPath) return null;
    if (flagPath.startsWith('http://') || flagPath.startsWith('https://')) {
      return flagPath;
    }
    const cleanBase = baseurl.replace(/\/$/, '');
    const cleanPath = flagPath.startsWith('/') ? flagPath : `/${flagPath}`;
    return `${cleanBase}${cleanPath}`;
  };

  return (
    <div className="country-flag-select-container" ref={dropdownRef}>
      <div
        className={`country-flag-select-header ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className={`country-flag-select-label ${selectedOption || isOpen ? 'has-value' : ''}`}>
          {label}
        </span>

        <div className="country-flag-selected-item">
          {selectedOption ? (
            <>
              {selectedOption.country_flag && (
                <img
                  src={getFlagUrl(selectedOption.country_flag)}
                  alt={selectedOption.label}
                  className="country-flag-img"
                />
              )}
              <span>{selectedOption.label}</span>
            </>
          ) : isOpen ? (
            <span style={{ color: '#9CA3AF', fontSize: '13px' }}>{placeholder}</span>
          ) : null}
        </div>

        <svg
          className={`country-flag-arrow ${isOpen ? 'open' : ''}`}
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L5 5L9 1" stroke="#424242" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {isOpen && (
        <div className="country-flag-select-dropdown">
          <div className="country-flag-search-box" onClick={(e) => e.stopPropagation()}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Country..."
              className="country-flag-search-input"
              autoFocus
            />
          </div>

          <div className="country-flag-options-list">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => {
                const flagSrc = getFlagUrl(option.country_flag);
                return (
                  <div
                    key={option.value}
                    className="country-flag-option"
                    onClick={() => handleSelect(option)}
                  >
                    {flagSrc && (
                      <img
                        src={flagSrc}
                        alt={option.label}
                        className="country-flag-img"
                      />
                    )}
                    <span>{option.label}</span>
                  </div>
                );
              })
            ) : (
              <div className="country-flag-option" style={{ color: '#9CA3AF' }}>
                No countries found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelectWithFlag;
